import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse, ClaimIntakeResponse } from '@mbp/core';
import { ClaimIntakeRequest } from 'app/modules/claims-authorization/models/models';

@Injectable({
  providedIn: 'root',
})
export class ClaimsService {
  constructor(private http: HttpClient) {}

  intake(request: ClaimIntakeRequest) {
    return this.http.post<ApiResponse<ClaimIntakeResponse>>(`/api/claims/intake`, request);
  }
}
